import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));

export const Route = createFileRoute("/admin/login")({
  component: AdminLogin,
});
